import { orgManagementClient } from '../../api/clients';
import changeOrganizationName from './change-org-name/change-org-name';
import createOrganization from './create/create-organization';
import getOrganizations from './get-organizations/get-organizations';

const organizationService = {
  createOrganization: createOrganization(orgManagementClient),
  getOrganizations: getOrganizations(orgManagementClient),
  changeOrganizationName: changeOrganizationName(orgManagementClient),
};

export default organizationService;
